import {
  type NewsFeedItem,
  type NewsFeedItemIncluded,
  type NewsFeedItemIncludedShift,
  type NewsFeedItemIncludedWorker,
  type NewsFeedItemIncludedWorkplace,
  NewsFeedItemType,
} from "../types";

export function extractIncludedEntitiesFromNewsFeedItems(
  newsFeedItem?: NewsFeedItem,
  included?: NewsFeedItemIncluded
) {
  const includedWorker = included?.find(
    (includedEntity) =>
      includedEntity.type === "worker" &&
      (newsFeedItem?.attributes.type === NewsFeedItemType.POST
        ? includedEntity.id === newsFeedItem?.attributes.createdBy
        : includedEntity.id === newsFeedItem?.attributes.recommendedBy)
  ) as NewsFeedItemIncludedWorker | undefined;
  const includedRecommendedWorker = included?.find(
    (includedEntity) =>
      newsFeedItem?.attributes.type === NewsFeedItemType.RECOMMENDATION &&
      includedEntity.type === "worker" &&
      includedEntity.id === newsFeedItem?.attributes.metadata.recommendedWorkerId
  ) as NewsFeedItemIncludedWorker | undefined;
  const includedReferredWorker = included?.find(
    (includedEntity) =>
      newsFeedItem?.attributes.type === NewsFeedItemType.POST &&
      includedEntity.type === "worker" &&
      includedEntity.id === newsFeedItem?.attributes.metadata.referredWorkerId
  ) as NewsFeedItemIncludedWorker | undefined;

  const includedShift = included?.find(
    (includedEntity) =>
      newsFeedItem?.attributes.type === NewsFeedItemType.POST &&
      includedEntity.type === "shift" &&
      includedEntity.id === newsFeedItem.attributes.metadata.shiftId
  ) as NewsFeedItemIncludedShift | undefined;

  const includedWorkplace = included?.find(
    (includedEntity) =>
      includedEntity.type === "workplace" &&
      includedEntity.id === newsFeedItem?.attributes.metadata.workplaceId
  ) as NewsFeedItemIncludedWorkplace | undefined;
  const includedRecommendedWorkplace = included?.find(
    (includedEntity) =>
      newsFeedItem?.attributes.type === NewsFeedItemType.RECOMMENDATION &&
      includedEntity.type === "workplace" &&
      includedEntity.id === newsFeedItem?.attributes.metadata.recommendedWorkplaceId
  ) as NewsFeedItemIncludedWorkplace | undefined;

  return {
    includedShift,
    includedWorkplace,
    includedRecommendedWorkplace,
    includedWorker,
    includedRecommendedWorker,
    includedReferredWorker,
  };
}
